import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "requirement",
  listKey: "requirements",
  itemKey: "requirement",
  getAll: types.GET_ALL_REQUIREMENTS,
  getAllResponse: types.GET_ALL_REQUIREMENTS_RESPONSE,
  getByIdResponse: types.GET_REQUIREMENT_BY_ID_RESPONSE,
});
